import React, { useEffect, useState } from 'react'
import styles from './style'
import propTypes from './prop'
import translator from 'src/translate'
import ContainerMediaGalery from 'src/container/image-gallery'
import URL from 'src/api/url/api'
import ComponentBoxContent from 'src/model/component-box'
import { cardChangeImageAction } from 'src/reducers/card/action'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import { QuestionFieldNames, QuestionMediaFieldNames } from 'src/model/card'
import { componentBoxShowAction } from 'src/reducers/component-box/action'
import { cardMediaDeleteAction } from 'src/reducers/card/action'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import { Grid, withStyles, Box, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { track } from '@amplitude/analytics-browser'

import { addMessageReceivedListener } from 'src/utils/signalR-connection/signalR-connection'
import { CoreButton, CoreIconButton } from 'src/components/core'
import VideoGallery from 'src/container/video-gallery'
const Media = props => {
  const {
    classes,
    entity,
    dispatch,
    filterType,
    imageURL,
    setImageURL,
    onOk,
    onRemove,
  } = props

  const [connectionEnabled, setConnectionEnabled] = useState(
    imageURL &&
      (imageURL.includes('/assets/gateway/ai-image-loading.gif') ||
        imageURL.includes(
          '/production/images/mini1631212909/5a14e263-32c7-4d3e-b0f6-258dba8bce73.png',
        ))
      ? true
      : false,
  )

  useEffect(() => {
    // Create a new SignalR connection

    if (!connectionEnabled) {
      return
    }

    addMessageReceivedListener(entity[QuestionFieldNames.ID], message => {
      if (entity[QuestionFieldNames.ID] == message[0]) {
        setImageURL(`${URL.STORAGE}${message[1]}`)

        dispatch(
          cardChangeImageAction(entity[QuestionFieldNames.ID], message[1]),
        )
      }
      // Handle the received message here
    })
  }, [])

  /**
   *
   */
  const imageButtonClickHandler = () => {
    handlePopoverClose()
    const { dispatch } = props
    track('add_image_video_clicked')
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
              "
            >
           
            <Icon
              icon="ic:round-add-a-photo"
              color="#00AB55"
              width="24"
              height="24"
            />
            <Typography
              style="
                margin-left: 8;
                color: #002E47;
                fontWeight: 600;
                fontSize: 16;
              "
            >
              Media Gallery
            </Typography>
          </div>`,
          component: (
            <ContainerMediaGalery
              setImageURL={setImageURL}
              onOk={onOk}
              onRemove={onRemove}
              filterType={filterType}
              cardEntity={entity}
            />
          ),
          maxHeight: '640px',
          variant: MessageBoxVariant.DRAGGABLE,
        }),
      ),
    )
  }
  /**
   *
   */
  const videoButtonClickHandler = () => {
    handlePopoverClose()
    const { dispatch } = props
    track('add_image_video_clicked')
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
              "
            >
           
            <Icon
              icon="ic:round-add-a-photo"
              color="#00AB55"
              width="24"
              height="24"
            />
            <Typography
              style="
                margin-left: 8;
                color: #002E47;
                fontWeight: 600;
                fontSize: 16;
              "
            >
              Media Gallery
            </Typography>
          </div>`,
          variant: MessageBoxVariant.DRAGGABLE,
          component: (
            <VideoGallery
              setImageURL={setImageURL}
              onOk={onOk}
              onRemove={onRemove}
              filterType={filterType}
              cardEntity={entity}
            />
          ),
        }),
      ),
    )
  }

  /**
   *
   * @param {*} e
   */
  const deleteButtonClickHandler = e => {
    const id =
      entity[QuestionFieldNames.QUESTION_MEDIAS][0][QuestionMediaFieldNames.ID]

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              translator._('action.no'),
              ButtonActionType.NO,
              e => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              translator._('action.yes'),
              ButtonActionType.DELETE,
              e => {
                dispatch(messageBoxHideAction())

                dispatch(
                  cardMediaDeleteAction(id, entity[QuestionFieldNames.ID]),
                )
              },
            ),
          ],
          title: translator._('message.delete'),
        }),
      ),
    )
  }

  const [anchorEl, setAnchorEl] = React.useState(null)

  /*const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget)
  }*/

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  /*   const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined */
  /**
   *
   */
  const addArea = () => {
    return (
      <Grid container justifyContent="center">
        <Grid item className={classes.grid}>
          <Box className={classes.box}>
            <Icon
              icon="proicons:photo"
              color="#919eab"
              width="36"
              height="36"
            />

            <Typography color="#919EAB" fontSize={'14px'}>
              Add image or video
            </Typography>
          </Box>
          <div className={classes.buttonContainer}>
            <CoreButton
              variant="outlined"
              onClick={imageButtonClickHandler}
              size="small"
            >
              Add Image
            </CoreButton>
            <CoreButton
              variant="outlined"
              size="small"
              onClick={videoButtonClickHandler}
            >
              Add Video
            </CoreButton>
          </div>
        </Grid>
      </Grid>
    )
  }

  /**
   *
   */
  const viewImageArea = () => {
    let srcURL = imageURL

    srcURL =
      srcURL && (srcURL.includes('https://') || srcURL.includes('http://'))
        ? srcURL
        : URL.STORAGE_QUESTION_IMAGE + srcURL

    return (
      <div className={classes.gridViewImage}>
        <div
          item
          style={{
            zIndex: 1,
            position: 'relative',
            margin: '0 auto',
            overflow: 'hidden',
            borderRadius: 16,
            width: 'fit-content',
          }}
        >
          <CoreIconButton
            className={classes.iconButton}
            size="small"
            color="white"
            //variant="text"
            onClick={deleteButtonClickHandler}
          >
            <Icon icon="bx:trash-alt" />
          </CoreIconButton>
          <img src={srcURL} alt={'img'} className={classes.img}></img>
        </div>
      </div>
    )
  }

  const parseYouTubeURL = url => {
    const baseURL = 'https://youtube.com/embed/'
    /*eslint-disabled */
    var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
    /*eslint-enabled */
    var match = url.match(regExp)
    if (match && match[2].length == 11) return baseURL + match[2]

    return url
  }

  const viewVideoArea = () => {
    let srcURL =
      entity[QuestionFieldNames.QUESTION_MEDIAS][0][
        QuestionMediaFieldNames.MEDIA_URL
      ]
    let nativeVideo = (
      <video width="100%" height="100%" controls>
        <source src={srcURL} type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>
    )

    let youtubeVideo
    try {
      youtubeVideo = (
        <iframe
          width="100%"
          height="100%"
          src={parseYouTubeURL(srcURL)}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
          allowFullScreen
        ></iframe>
      )
    } catch (error) {}

    let videoView =
      srcURL && srcURL.includes('youtu') ? youtubeVideo : nativeVideo

    return (
      <Grid container justifyContent="center">
        <Grid item className={classes.grid}>
          <Grid
            className={classes.childGrid}
            style={{
              background: 'black',
              height: '100%',
              position: 'relative',
            }}
          >
            <CoreIconButton
              className={classes.iconButton}
              size="small"
              color="white"
              onClick={deleteButtonClickHandler}
            >
              <Icon icon="bx:trash-alt" />
            </CoreIconButton>
            {videoView}
          </Grid>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container justifyContent="center">
      {entity[QuestionFieldNames.QUESTION_MEDIAS].filter(
        item => item[QuestionMediaFieldNames.MEDIA_TYPE_ID] == 1,
      ).length > 0 && viewImageArea()}

      {entity[QuestionFieldNames.QUESTION_MEDIAS].filter(
        item => item[QuestionMediaFieldNames.MEDIA_TYPE_ID] == 2,
      ).length > 0 && viewVideoArea()}
      {entity[QuestionFieldNames.QUESTION_MEDIAS].length === 0 && addArea()}
    </Grid>
  )
}

Media.propTypes = propTypes

export default withStyles(styles)(Media)
